import React,{useEffect,useCallback,useState,useRef} from 'react';
import './TopBar.scss';
import {ReactComponent as OrangeArrow} from "../../assets/images/icons/orangeArrow.svg";
import TopBarProfile from "./Components/TopBarProfile/TopBarProfile";
import TopBarClock from "./Components/TopBarClock/TopBarClock";
import LoungeAvailable from "./Components/LoungeAvailable/LoungeAvailable";
import useBoolean from "../../hooks/useBoolean";
import {useActualLoungeOccupation} from "../../services/modelUtils/loungeUtils";
import {ReactComponent as PlusIcon} from "../../assets/images/icons/plusIcon.svg";
import TopBarExchangeRate from "./Components/TopBarExchangeRate/TopBarExchangeRate";
import LoungeMapModal from "../LoungeMapModal/LoungeMapModal";
import {isUserInactiveFor, USER_ACTIVITY_EVENT} from "../../services/userActivityUtils";


const OCCUPATION_REFRESH_TIMEOUT = 30000;
const OCCUPATION_IDLE_THRESHOLD = 30000;

const TopBar = ()=>{

    const [isOpenLoungeOccupation,,closeLoungeOccupation,isOpenToggle] = useBoolean();

    const {lounge, refreshOccupation}=useActualLoungeOccupation();

    const occupationTimeoutRef = useRef(0);
    const occupationRequestInFlightRef = useRef(false);

    useEffect(() => {
        let mounted = true;

        const scheduleNextOccupationRefresh = () => {
            clearTimeout(occupationTimeoutRef.current);

            if (mounted) {
                occupationTimeoutRef.current = setTimeout(
                    loadOccupation,
                    OCCUPATION_REFRESH_TIMEOUT
                );
            }
        };

        const finishOccupationRefresh = () => {
            occupationRequestInFlightRef.current = false;
            scheduleNextOccupationRefresh();
        };

        function loadOccupation() {
            clearTimeout(occupationTimeoutRef.current);

            if (!mounted)
                return;

            if (isUserInactiveFor(OCCUPATION_IDLE_THRESHOLD)) {
                scheduleNextOccupationRefresh();
                return;
            }

            if (occupationRequestInFlightRef.current)
                return;

            occupationRequestInFlightRef.current = true;

            Promise.resolve(refreshOccupation())
                .then(
                    finishOccupationRefresh,
                    finishOccupationRefresh
                );
        }

        const reloadAfterActivity = () => {
            clearTimeout(occupationTimeoutRef.current);
            loadOccupation();
        };

        window.addEventListener(
            USER_ACTIVITY_EVENT,
            reloadAfterActivity
        );

        loadOccupation();

        return () => {
            mounted = false;

            window.removeEventListener(
                USER_ACTIVITY_EVENT,
                reloadAfterActivity
            );

            clearTimeout(occupationTimeoutRef.current);
        };
    }, [refreshOccupation]);

    const occupied= (lounge && lounge.loungeMap && lounge.loungeMap.occupiedSeats) || 0;
    const total= (lounge && lounge.loungeMap && lounge.loungeMap.totalSeats) || 0;

    const [subMenu,,,ToggleSubMenu] = useBoolean();

    const [showingMap, setShowingMap]=useState(null);
    const stopShowingMap = useCallback(()=>setShowingMap(null), []);
    const showLoungeMap = useCallback((lounge)=>{
        closeLoungeOccupation();
        setShowingMap(lounge.id);
    },[closeLoungeOccupation]);

    return(
        <>
            <div className='TopBar animated fadeInDown faster'>
                {window.matchMedia("(max-width: 1025px)").matches &&
                <div onClick={ToggleSubMenu} className="TopBar-plusIcon">
                    <PlusIcon/>
                </div>
                }
                {window.matchMedia("(min-width:1026px)").matches &&
                    <>
                    <div className="TopBar-ocupacion">
                        <p className="TopBar-ocupacion-text">{lounge && lounge.name}</p>
                        <p className="TopBar-progress-score">{lounge? `${occupied} / ${total}`:'-'}</p>
                        <progress className="TopBar-progress" max="1" value={total? occupied/total : 0} />
                    </div>
                    <div className="TopBar-disponibilidad">
                    <p>Disponibilidad en otras salas</p>
                    <button onClick={isOpenToggle}  className="TopBar-disponibilidad-drop">
                    <OrangeArrow/>
                    </button>
                {isOpenLoungeOccupation &&
                    <LoungeAvailable
                        onSelect={showLoungeMap}
                    />}
                    </div>
                    </>
                }
                <TopBarClock/>

                <TopBarExchangeRate/>

                <TopBarProfile/>
            </div>
            {subMenu && window.matchMedia("(max-width: 1025px)").matches &&
            <div className="TopBar-subMenu animated fadeInDown faster">
                <div className="TopBar-ocupacion">
                    <p className="TopBar-ocupacion-text">{lounge && lounge.name}</p>
                    <p className="TopBar-progress-score">{lounge? `${occupied} / ${total}`:'-'}</p>
                    <progress className="TopBar-progress" max="1" value={total? occupied/total : 0} />
                </div>
                <div className="TopBar-disponibilidad">
                    <p>Disponibilidad en otras salas</p>
                    <button onClick={isOpenToggle} onBlur={closeLoungeOccupation}  className="TopBar-disponibilidad-drop">
                        <OrangeArrow/>
                    </button>
                    {isOpenLoungeOccupation &&
                    <LoungeAvailable/>}
                </div>
            </div>
            }

            {showingMap &&
                <LoungeMapModal
                    loungeId={showingMap}
                    onClose={stopShowingMap}
                />}

        </>
    )
};
TopBar.displayName='TopBar';
export default  TopBar;
